import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import {trigger, state, animate, transition, style,keyframes} from '@angular/animations';
import { EditPopup } from './edit-popup';
import { SharedService } from './shared.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from './base.component';
//import { DispatchBoardService } from './dispatch-board.service';
//import { SpErrors } from './dispatch-board.model';
@Component({
    selector: 'confirm-popup',
    animations: [
        trigger('isVisibleChanged', [
            state('true', style({ opacity: 1, transform: 'scale(1.0)' })),
            state('false', style({ opacity: 0, transform: 'scale(0.0)' })),
            transition('1 => 0', animate('300ms')),
            transition('0 => 1', animate('900ms'))
        ])
    ],
    templateUrl: 'confirm-popup.component.html'
})
export class ConfirmPopupComponent extends BaseComponent implements OnInit {
    @Output() done = new EventEmitter();
    @Input() isVisible: boolean = false;
    @Input() confirmMessage: string;
    @Input() isAddMode: boolean = false;
    constructor(protected sharedService: SharedService, protected translate: TranslateService, ) {
        super(sharedService, translate);
    }
    ngOnInit() {
        //alert(this.isVisible);
        //if (typeof this.jobid != "undefined")
        this.isVisible = false;
    }
    no(success?: boolean) {
        this.isVisible = false;
        this.done.emit({ "key": "No", "value": success,"isAddMode":this.isAddMode });
    }
    confirm(success?: boolean) {
        this.done.emit({ "key": "Yes", "value": false ,"isAddMode":this.isAddMode});
        this.isVisible = false;

    }
}
